<template>
  <div class="pagination" v-if="visibility">
    <button @click="prevPage" class="prev" :disabled="currentPage === 1">
      <span class="icon-arrow-left-grey icon"></span>
    </button>
    <ul class="page-list">
      <li v-for="page in displayedPages" :key="page">
        <span v-if="page === '...'" class="ellipsis">{{ page }}</span>
        <span v-else @click="gotoPage(page)" :class="{ active: currentPage === page }">{{ page }}</span>
      </li>
    </ul>
    <button @click="nextPage" class="next" :disabled="currentPage === totalPages">
      <span class="icon-arrow-right-grey icon"></span>
    </button>
  </div>
</template>

<script>
  export default {
    name: 'Pagination',
    props: {
      totalPages: {
        type: Number,
        required: true
      },
      currentPage: {
        type: Number,
        required: true
      }
    },
    computed: {
      displayedPages() {
        const pages = []
        const minDisplayPages = this.totalPages <= 8 ? this.totalPages : 4
        const currentPageIndex = this.currentPage - 1

        if (this.totalPages <= 8) {
          for (let i = 1; i <= this.totalPages; i += 1) {
            pages.push(i)
          }
        } else if (currentPageIndex < 3) {
          for (let i = 1; i <= minDisplayPages - 1; i += 1) {
            pages.push(i)
          }
          pages.push('...')
          pages.push(this.totalPages)
        } else if (currentPageIndex >= this.totalPages - 3) {
          pages.push(1)
          pages.push('...')
          for (let i = this.totalPages - minDisplayPages + 2; i <= this.totalPages; i += 1) {
            pages.push(i)
          }
        } else {
          pages.push(1)
          pages.push('...')
          for (let i = currentPageIndex - 1; i <= currentPageIndex + 1; i += 1) {
            pages.push(i + 1)
          }
          pages.push('...')
          pages.push(this.totalPages)
        }
        return pages
      },
      visibility() {
        return this.totalPages > 1
      }
    },
    methods: {
      prevPage() {
        this.$emit('prev-page')
      },
      nextPage() {
        this.$emit('next-page')
      },
      gotoPage(page) {
        this.$emit('goto-page', page)
      }
    }
  }
</script>
